import { useState } from 'react';
import { Markdown, Tab } from '@scale/scaleui';
import { TextDiff } from '../components/TextDiff';

export function ResponseRewriteDisplay({
  responseMarkdown,
  rewriteMarkdown,
}: {
  responseMarkdown?: string;
  rewriteMarkdown?: string;
}) {
  const [tabIndex, setTabIndex] = useState<number>(0);
  const showDiff = !!rewriteMarkdown && !!responseMarkdown;

  return (
    <div className="rounded-lg border border-neutral-200">
      <Tab.Group selectedIndex={tabIndex} onChange={setTabIndex}>
        <Tab.List className="pt-2 px-4">
          {responseMarkdown && <Tab>Model Response</Tab>}
          {rewriteMarkdown && <Tab>Human Rewrite</Tab>}
          {showDiff && <Tab>Markdown Diff</Tab>}
        </Tab.List>
        <Tab.Panels className="p-4 bg-neutral-50 rounded-b-lg">
          {responseMarkdown && (
            <Tab.Panel>
              <Markdown markdown={responseMarkdown} />
            </Tab.Panel>
          )}
          {rewriteMarkdown && (
            <Tab.Panel>
              <Markdown markdown={rewriteMarkdown} />
            </Tab.Panel>
          )}
          {showDiff && (
            <Tab.Panel>
              <TextDiff originalText={responseMarkdown} newText={rewriteMarkdown} />
            </Tab.Panel>
          )}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}
